import React from 'react';
import Icon from '../../../components/AppIcon';

const PlayerStatusCard = ({ stats }) => {
  return (
    <div className="player-status-card bg-card border-2 border-primary rounded-sm p-4 md:p-6 lg:p-8 shadow-glow-cyan-md">
      <div className="flex items-center gap-3 md:gap-4 mb-4 md:mb-6">
        <div className="w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 bg-primary/20 rounded-sm flex items-center justify-center border border-primary shadow-glow-cyan-sm">
          <Icon name="User" size={24} color="var(--color-primary)" />
        </div>
        <div>
          <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold neon-text-cyan">
            {stats?.playerName}
          </h2>
          <p className="text-xs md:text-sm font-caption text-muted-foreground tracking-wide">
            CYBER WARRIOR
          </p>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3 md:gap-4 lg:gap-6">
        <div className="bg-background border border-accent/30 rounded-sm p-3 md:p-4 lg:p-5">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Flame" size={18} color="var(--color-warning)" />
            <span className="text-xs md:text-sm font-caption text-muted-foreground">
              CURRENT STREAK
            </span>
          </div>
          <p className="text-2xl md:text-3xl lg:text-4xl font-data text-warning">
            {stats?.currentStreak}
          </p>
        </div>

        <div className="bg-background border border-accent/30 rounded-sm p-3 md:p-4 lg:p-5">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Gem" size={18} color="var(--color-accent)" />
            <span className="text-xs md:text-sm font-caption text-muted-foreground">
              TOTAL GEMS
            </span>
          </div>
          <p className="text-2xl md:text-3xl lg:text-4xl font-data text-accent">
            {stats?.totalGems}
          </p>
        </div>

        <div className="bg-background border border-secondary/30 rounded-sm p-3 md:p-4 lg:p-5">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Brain" size={18} color="var(--color-secondary)" />
            <span className="text-xs md:text-sm font-caption text-muted-foreground">
              AI MOODS
            </span>
          </div>
          <p className="text-2xl md:text-3xl lg:text-4xl font-data text-secondary">
            {stats?.unlockedMoods}/{stats?.totalMoods}
          </p>
        </div>

        <div className="bg-background border border-primary/30 rounded-sm p-3 md:p-4 lg:p-5">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Trophy" size={18} color="var(--color-primary)" />
            <span className="text-xs md:text-sm font-caption text-muted-foreground">
              WIN RATE
            </span>
          </div>
          <p className="text-2xl md:text-3xl lg:text-4xl font-data text-primary">
            {stats?.winRate}%
          </p>
        </div>
      </div>
      <div className="mt-4 md:mt-6 pt-4 md:pt-6 border-t border-primary/30">
        <div className="flex items-center justify-between mb-2">
          <span className="text-xs md:text-sm font-caption text-muted-foreground">
            TOTAL GAMES PLAYED
          </span>
          <span className="text-sm md:text-base font-data text-foreground">
            {stats?.totalGames}
          </span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-xs md:text-sm font-caption text-muted-foreground">
            BEST STREAK
          </span>
          <span className="text-sm md:text-base font-data text-warning">
            {stats?.bestStreak}
          </span>
        </div>
      </div>
    </div>
  );
};

export default PlayerStatusCard;